import { createUseStyles } from 'react-jss';

const styles = createUseStyles(theme => {
  const { breakpoints, spacing } = theme;

  return {
    appsGrid: {
      display: 'grid',
      gridColumnGap: `${spacing['4']}px`,
      gridRowGap: `${spacing['4']}px`,
      gridTemplateColumns: 'repeat(auto-fill, minmax(max(23%, 235px), 1fr))',

      [`@media screen and (min-width: ${breakpoints.md}px)`]: {
        marginTop: `${spacing['6']}px`,
      },
      [`@media screen and (max-width: ${breakpoints.md - 1}px)`]: {
        marginTop: `${spacing['5']}px`,
      },
      marginBottom: `${spacing['6']}px`,
    },
  };
});

export default styles;
